/** @format */
import React from 'react';

import {
    LinkList,
    LinkListVariant,
} from '@toucan/client/blocks/components/link-list';

import { MobileLinksProps } from './types';

export const MobileLinks = ({ links }: MobileLinksProps) => {
    const flattenLinks = links.flatMap((linkList) => linkList.links);

    return <LinkList links={flattenLinks} variant={LinkListVariant.BLOCK} />;
};
